import React from 'react'
import { Link } from 'react-router-dom'
import Style from '../details.module.css'
import { paths } from '../../../../app/routes'
const MetaData = ({ connector, canViewToken, onViewToken, isBiDashboardEnable, biDashboardUrl }) => {
    const { source, target } = connector
    const rows = [
        { label: source.name, value: source.version },
        { label: target.name, value: target.version },
        { label: 'Product Type', value: connector.featureName }
    ]
    const isHostedSetup = source.type === 1 || target.type === 1
    return (
        <>
            <div className={`card-header ${Style.cardHeader}`}>
                <div className={Style.cardHeaderTitle}>
                    <span>Meta Data</span>
                </div>
            </div>

            <div className={`card-body ${Style.metaBody}`}>
                <dl className={Style.metaList}>
                    {rows.map((row) => (
                        <div className={Style.metaRow} key={row.label}>
                            <dt className={Style.metaLabel} title={row.label}>{row.label}</dt>
                            <dd className={Style.metaValue}>{row.value || '--'}</dd>
                        </div>
                    ))}
                </dl>

                <p className={Style.sectionTitle}>Other Options</p>

                <div className={Style.actionList}>
                    <Link
                        className={Style.actionItem}
                        to={paths.setup(connector.connectorId, connector.instanceId)}
                    >
                        <span className={Style.actionIcon}>
                            <i className={isHostedSetup ? 'uil-sliders-v-alt' : 'uil-download-alt'} aria-hidden="true" />
                        </span>
                        <span className={Style.actionLabel}>
                            {isHostedSetup ? 'Setup' : 'Download Installers'}
                        </span>
                        <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                    </Link>

                    <Link
                        className={Style.actionItem}
                        to={paths.configurations(connector.connectorId, connector.instanceId)}
                    >
                        <span className={Style.actionIcon}><i className="uil-setting" aria-hidden="true" /></span>
                        <span className={Style.actionLabel}>Configuration</span>
                        <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                    </Link>

                    {canViewToken ? (
                        <button type="button" className={Style.actionItem} onClick={onViewToken}>
                            <span className={Style.actionIcon}><i className="uil-key-skeleton" aria-hidden="true" /></span>
                            <span className={Style.actionLabel}>View Token</span>
                            <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                        </button>
                    ) : null}

                    {isBiDashboardEnable ?
                        <a
                            className={Style.actionItem}
                            href={biDashboardUrl}
                            target="_blank"
                            rel="opener"
                        >
                            <span className={Style.actionIcon}><i className="uil-chart-line" aria-hidden="true" /></span>
                            <span className={Style.actionLabel}>BI Dashboard</span>
                            <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                        </a>
                        : null
                    }
                </div>
            </div>
        </>
    )
}

export default MetaData
